export default __webpack_public_path__ + "static/media/bell-white.ea585147.svg";